export default __webpack_public_path__ + "static/media/stripes.b61c3ca2.svg";